import { ErrorHandler, Injectable, inject } from '@angular/core';

import { Logger } from '../logging/logger.service';
import { normalizeHttpError } from './error-normalizer';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly logger = inject(Logger);

  public handleError(error: unknown): void {
    const normalized = normalizeHttpError(error);

    this.logger.error(normalized.userMessage, {
      correlationId: normalized.correlationId,
      feature: 'core',
      operation: 'global-error-handler',
      severity: normalized.severity,
      code: normalized.code,
      technicalMessage: normalized.technicalMessage,
    });
  }
}
